import type { TenantSettings } from "@/types/tenant";

export type DeliveryZone = {
  id: string;
  zoneName: string;
  zoneFee: number;
  active: boolean;
  displayOrder: number;
};

export function fulfillmentOptions(settings: TenantSettings) {
  return {
    pickupEnabled: settings.pickupEnabled !== false,
    pickupFee: money(settings.pickupFee),
    shippingEnabled: settings.shippingEnabled !== false,
    shippingRateMode: settings.shippingRateMode === "flat" ? "flat" as const : "product" as const,
    shippingFlatRate: money(settings.shippingFlatRate),
    deliveryEnabled: settings.deliveryEnabled === true,
    checkoutEnabled: settings.checkoutEnabled !== false,
    orderInquiryNote: typeof settings.orderInquiryNote === "string" ? settings.orderInquiryNote : "",
  };
}

function money(value: unknown) {
  const amount = typeof value === "number" ? value : Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
}
